import { useDispatch } from "react-redux";

import {
  closeModal,
  expandMyRecentOpenHouses,
  expandMyUpcomingOpenHouses,
  openModal,
  sendViewOHonMyActivity
} from "../../slices/uiSlice";

export const useUIBehavior = () => {
  const dispatch = useDispatch();

  return {
    closeModal: () => dispatch(closeModal()),
    openModal: () => dispatch(openModal()),
    expandMyRecentOH: () => dispatch(expandMyRecentOpenHouses()),
    expandMyUpcomingOH: () => dispatch(expandMyUpcomingOpenHouses()),
    sendViewOHonMyActivity: (
      recentNumberOpenHouses,
      upcomingNumberOpenHouses
    ) =>
      dispatch(
        sendViewOHonMyActivity({
          recentNumberOpenHouses,
          upcomingNumberOpenHouses
        })
      )
  };
};
